import { CardHistoryPage, CardsPage, CardStatementPage, } from "@/modules/card/pages";
import { FeatureToggle } from "@/shared/common/enums";
import { FeatureToggleRoute } from "@/shared/components";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

enum Paths {
  Cards = "cards",
  CardHistory = ":cardId/history",
  CardStatement = ":cardId/statement",
}

export const cardRoutes: RouteObject = {
  path: Paths.Cards,
  element: <Layout/>,
  handle: {
    breadcrumb: () => ({ key: "breadcrumb.cards" })
  },
  children: [
    { path: "", element: <CardsPage/> },
    {
      path: Paths.CardHistory,
      element: <CardHistoryPage/>,
      handle: {
        breadcrumb: () => ({
          key: "breadcrumb.cardHistory",
        })
      },
    },
    {
      path: Paths.CardStatement,
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isCardStatementAvailable}
          element={<CardStatementPage/>}
        />
      ),
      handle: {
        breadcrumb: () => ({
          key: "breadcrumb.cardStatement",
        })
      },
    },
  ],
};
